import { RSAA } from 'redux-api-middleware';
import config from 'config';

export const updateDynamicSwitchGroupList = (pageSize, page, sorted, filtered, codexVersionId) => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/cat/codex-version/${codexVersionId}/dynamic-switch-groups/`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        'UPDATE_DYNAMIC_SWITCH_GROUP_LIST_REQUEST',
        'UPDATE_DYNAMIC_SWITCH_GROUP_LIST_SUCCESS',
        'UPDATE_DYNAMIC_SWITCH_GROUP_LIST_FAILURE'
      ]
    }
  };
};

export const updateDynamicSwitchGroupListState = (state) => {
  return {
    type: "UPDATE_DYNAMIC_SWITCH_GROUP_LIST_STATE",
    payload: {listState: state}
  }
};

export const resetError = () => {
  return {
    type: "RESET_ERROR_MESSAGE_DYNAMIC_SWITCH_GROUP_LIST"
  }
};
